import {Box, Button, Card, Dialog, Grid, Typography} from "@material-ui/core";
import moment from "moment";
import Image from "material-ui-image";
import {ReactComponent as LogoSVG} from "../../Images/logo.svg";
import {servicesChat, setType} from "../../Constants/serviceType";
import React, {useEffect, useState} from "react";
import {makeStyles, Theme, useTheme} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {setSelectedAppointment as setAppointmentToRedux} from "../../redux/appointment/appointment.actions";
import {deleteInter, setChat} from "../../redux/chat/chat.actions";
import {setEquals} from "../../redux/chat/chat.reducers";
import {useHistory} from "react-router-dom";


const useStyle = makeStyles((theme: Theme) => ({
    selectedPet: {
        boxShadow: "0 0 0 3px #8574F5",
        borderRadius: 5,
    },
    avatar__addNew: {
        marginTop: 10,
    },
    sectionText: {
        textAlign: "center",
        "@media (max-width: 360px)": {
            textAlign: "left"
        }
    },
    appointmentCard: {
        "&.MuiCard-root": {
            padding: "5px 20px",
            width: "100%",
            [theme.breakpoints.down("sm")]: {
                padding: "12px 12px",
                width: 248,
                margin: "0 auto",
            }

        },
    },
    gridContent: {
        justifyContent: "space-between"
    },
    appointmentCardBtn: {
        height: "52px",
        lineHeight: "16px"
    },
}));

interface BookAgainCardProps {
    title: string,
    handleNext?: () => void,
    nextBtnLabel?: string,
    vetProfile: any,
    upcomingAppt?: boolean,
    appt: any,
}

const BookAgainCard: React.FC<BookAgainCardProps> = (
    {
        title,
        handleNext,
        nextBtnLabel,
        vetProfile,
        upcomingAppt,
        appt,
    }
) => {
    const classes = useStyle();
    const history = useHistory();
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [openChatDialog, setOpenChatDialog] = useState(false);
    const [chatData, setChatData] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [isModalVisible, setModalVisibility] = useState(false);
    const [equalsScheduled, setEqualsScheduled] = useState(false);
    const [showChat, setShowChat] = useState(false);
    const [buttonText, setButtonText] = useState("Join Appointment");
    const [appointmentDone, setAppointmentDone] = useState(false);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const user = useSelector((state: RootState) => state?.user);

    useEffect(() => {
        if(openChatDialog) {
            setTimeout(() => {
                document.querySelector(".MuiDialog-container").removeAttribute("tabindex");
            }, 3000);
        }
    }, [openChatDialog]);

    const handleChatData = (open, data, over) => {
        if (open) {
            setOpenChatDialog(true);
            setChatData({data, over});
        } else {
            setOpenChatDialog(false);
            setChatData({});
        }
    };

    const handleCloseTranscript = () => {
        setOpenChatDialog(false);
        setChatData({});
    };

    const handleAppointmentAfterAnHour = () => {
        if (!servicesChat.includes(appt.type)) {
            setShowChat(false);
        } else {
            setButtonText("View Transcript");
            setAppointmentDone(true);
            setShowChat(true);
        }
    };

    useEffect(() => {
        if (appt) {
            const scheduledTime = moment(appt.scheduledDate);
            const timeDiff = scheduledTime.diff(moment(), "minutes");
            if (timeDiff < 0) {
                if (Math.abs(timeDiff) >= 60) {
                    handleAppointmentAfterAnHour();
                } else {
                    setShowChat(true);
                    setEqualsScheduled(true);
                    setTimeout(() => {
                        handleAppointmentAfterAnHour();
                    }, (60 - Math.abs(timeDiff)) * 60 * 1000);
                }
            }
            if (timeDiff >= 0 && timeDiff <= 35791) {
                setTimeout(() => {
                    setShowChat(true);
                    setEqualsScheduled(true);
                    setButtonText("Join Appointment");
                }, (timeDiff - 5) * 60000);
            }
        }
    }, []);

    useEffect(() => {
        if (equalsScheduled) {
            setTimeout(() => {
                handleAppointmentAfterAnHour();
            }, 3600 * 1000);
        }
    }, [equalsScheduled]);

    const joinAppt = () => {
        dispatch(deleteInter());
        dispatch(setChat({data: {item: appt, vetProfile}, over: appointmentDone}));
        dispatch(setEquals(equalsScheduled));
        //handleChatData(true, {item: appt, vetProfile}, appointmentDone);
        dispatch(setAppointmentToRedux(appt));
        history.push("/chat");
    };

    return (
        <>
            <Box>
                <Box display="flex" justifyContent={isMobile ? "center" : "flex-start"}
                    marginBottom="34px">
                    <Typography variant="h2">
                        {title}
                    </Typography>
                </Box>
                <Card variant="outlined" className={classes.appointmentCard}>

                    <Grid container className={classes.gridContent} alignItems="center">
                        <Grid item>
                            <Typography color="textSecondary">
                                {moment(appt.scheduledDate).format("dddd, MMMM D, YYYY")}
                            </Typography>
                            <Box display="flex">
                                <Box display="flex" justifyContent="center"
                                    alignItems="center" width="80px"
                                    height="80px">
                                    {vetProfile?.image ?
                                        <Image imageStyle={{objectFit: "cover"}}
                                            src={vetProfile.image}
                                            errorIcon={<LogoSVG/>}
                                            style={{width: "100%"}}
                                        />
                                        :
                                        <LogoSVG/>
                                    }
                                </Box>
                                <Box marginLeft="32px">
                                    <Grid container direction="column">
                                        <Box>
                                            {`Dr. ${vetProfile.firstName} ${vetProfile.lastName}`}
                                        </Box>
                                        <Box maxWidth={"77px"} overflow={"hidden"} textOverflow={"ellipsis"} whiteSpace={"nowrap"}>
                                            {appt.animal.name}
                                        </Box>
                                        <Box>
                                            {setType(appt.type)}
                                        </Box>
                                    </Grid>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item md={5} xs={12}>
                            <Button
                                className={classes.appointmentCardBtn}
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={upcomingAppt ? joinAppt : handleNext}
                                disableElevation
                                disabled={upcomingAppt ? (!showChat || appt.pending) : false}
                            >
                                {upcomingAppt ? (appt.pending ? "Pending" : buttonText) : nextBtnLabel}
                            </Button>
                        </Grid>
                    </Grid>
                </Card>
            </Box>
        </>
    );
};

export default BookAgainCard;
